import { createGlobalStyle } from 'styled-components';
import RobotoMonoRegular from '../assets/fonts/RobotoMono-Regular.ttf';
import MontserratSemiBold from '../assets/fonts/Montserrat-SemiBold.ttf';
import MontserratBold from '../assets/fonts/Montserrat-Bold.ttf';

const Typography = createGlobalStyle`
  @font-face {
    font-family: 'RobotoMono Regular';
    src: url(${RobotoMonoRegular});
    font-style: normal;
  }
  @font-face {
    font-family: 'Montserrat SemiBold';
    src: url(${MontserratSemiBold});
    font-style: normal;
  }
  @font-face {
    font-family: 'Montserrat Bold';
    src: url(${MontserratBold});
    font-style: normal;
  }
  html{
    font-family: 'RobotoMono Regular',sans-serif;
    color: var(--gray-1);
  }
  *{
    font-family: 'RobotoMono Regular',sans-serif;

    
  }
  h1,h2,h3,h4,h5,h6{
    font-family: 'Montserrat SemiBold',sans-serif;
  }
  p {
    color: white !important;
  }
  a{
    text-decoration: none;
    color: white;
  }
  li {
    color: white !important;
  }

`;

export default Typography;


// ПРОБЛЕМА ШРИФТОВ
/**
 * https://www.telerik.com/blogs/improving-site-font-loader
 * https://blog.harveydelaney.com/fixing-fouc-in-your-webpack-build/
 */

